<div id="content">
  <div class="page-title">
    <h1>{{ page_title }}</h1>
    <button mat-flat-button color="accent" type="button" (click)="openCreateDialog()">
      <mat-icon>add</mat-icon>
      Añadir contrato
    </button>
  </div>

  <div class="bisual-table">
    <div class="bisual-table-container">
      <table mat-table [dataSource]="data_source">
        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef>Estado</th>
          <td mat-cell *matCellDef="let contract">{{ contract.is_active ? 'Activo' : 'Inactivo' }}</td>
        </ng-container>

        <ng-container matColumnDef="start_date">
          <th mat-header-cell *matHeaderCellDef>Inicio</th>
          <td mat-cell *matCellDef="let contract">{{ contract.start_date | date: 'dd/MM/yyyy' }}</td>
        </ng-container>

        <ng-container matColumnDef="end_date">
          <th mat-header-cell *matHeaderCellDef>Fin</th>
          <td mat-cell *matCellDef="let contract">
            {{ contract.end_date ? (contract.end_date | date: 'dd/MM/yyyy') : 'Abierto' }}
          </td>
        </ng-container>

        <ng-container matColumnDef="departments">
          <th mat-header-cell *matHeaderCellDef>Departamentos actuales</th>
          <td mat-cell *matCellDef="let contract">{{ contract.departments_label }}</td>
        </ng-container>

        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let contract">
            <button mat-icon-button type="button" [matMenuTriggerFor]="menu">
              <mat-icon>more_vert</mat-icon>
            </button>
            <mat-menu #menu="matMenu">
              <button mat-menu-item type="button" (click)="openConditionDialog(contract)">
                <mat-icon>add</mat-icon>
                Añadir condición variable
              </button>
              @for (condition of contract.partner_contract_variable_conditions; track condition.id) {
                <button mat-menu-item type="button" (click)="openConditionDialog(contract, condition)">
                  <mat-icon>edit</mat-icon>
                  Editar condición {{ condition.start_date | date: 'dd/MM/yyyy' }}
                </button>
                <button mat-menu-item type="button" (click)="deleteCondition(contract, condition)">
                  <mat-icon>delete</mat-icon>
                  Eliminar condición {{ condition.start_date | date: 'dd/MM/yyyy' }}
                </button>
              }
              <button mat-menu-item type="button" (click)="deleteContract(contract)">
                <mat-icon>delete_forever</mat-icon>
                Eliminar contrato
              </button>
            </mat-menu>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayed_columns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayed_columns"></tr>
      </table>
    </div>
  </div>
</div>
